/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SsoRedirectResponse {
    getFixupPrototypeFunction() { return SsoRedirectResponse.fixupPrototype; }

    static newInstance(model: Partial<SsoRedirectResponse>): SsoRedirectResponse {
        let obj = Object.assign(new SsoRedirectResponse(), model);
        SsoRedirectResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SsoRedirectResponse>): SsoRedirectResponse {
        if (!model) return null;
        return SsoRedirectResponse.newInstance(<SsoRedirectResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SsoRedirectResponse) {
        if (!obj) return;

        models.SsoRedirectResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SsoRedirectResponse): boolean {
        Object.setPrototypeOf(obj, SsoRedirectResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * SSO Redirected URL
     */
    sso_redirect_url: string;

}
